import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import useLanguage from "../../utils/useLanguage";
import { redirectToBattleNetLogin } from "../../utils/auth";

// Public/storefront navbar: logo, Shop link, language switch, login button only.
const PublicNavbar = () => {
  const { lang, toggleLang } = useLanguage();

  return (
    <nav className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 w-full shadow-lg border-b border-gray-700 relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 gap-3">
          {/* Logo - left */}
          <a href="/" className="flex-shrink-0 flex items-center group min-w-0">
            <div className="mr-2 sm:mr-3">
              <img src="/new-logo-terra.png" alt="Terra Logo" className="h-9 w-9 sm:h-10 sm:w-10 drop-shadow-lg" />
            </div>
            <span className="text-white text-xl sm:text-3xl font-bold font-serif tracking-wider group-hover:text-blue-200 transition-colors duration-300 truncate">
              TERRA
            </span>
          </a>

          {/* Right side */}
          <div className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
            <a
              href="/shop"
              className="text-gray-300 hover:text-white px-2 sm:px-3 py-2 rounded-lg text-sm font-semibold transition-all duration-200"
            >
              {lang === "bg" ? "Магазин" : "Shop"}
            </a>

            <button
              onClick={toggleLang}
              className="flex items-center space-x-1.5 text-gray-300 hover:text-white border border-gray-600 hover:border-gray-400 px-2 sm:px-3 py-1.5 rounded-lg text-xs sm:text-sm font-semibold transition-all duration-200"
              title={lang === "en" ? "Switch to Bulgarian" : "Смени на Английски"}
            >
              <span>{lang === "en" ? "🇧🇬 БГ" : "🇬🇧 EN"}</span>
            </button>

            <button
              onClick={redirectToBattleNetLogin}
              className="bg-blue-600 hover:bg-blue-700 text-white px-3 sm:px-5 py-2 rounded-lg text-sm font-medium transition-all duration-300 shadow-md"
            >
              {lang === "bg" ? "Влез" : "Sign In"}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;
